import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import NextLink from 'next/link';
import useInterval from '../../../utils/useInterval';
import Box from '@material-ui/core/Box';
import Wrap from './Wrap';

const TRANSITION_TIME = '1500ms';
const INTERVAL_DELAY = 3000;

const useStyles = makeStyles(theme => ({
  galleryWrap: {
    width: '100%',
    overflow: 'hidden',
    minHeight: 500,
    [theme.breakpoints.only('xs')]: {
      minHeight: 250,
    },
  },
  slide: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'absolute',
    minWidth: '100%',
    minHeight: 500,
    '&:after': {
      top: 0,
      left: 0,
      position: 'absolute',
      display: 'block',
      opacity: 0.0,
      backgroundColor: theme.palette.common.white,
      minWidth: '100%',
      minHeight: '100%',
      content: '""',
    },
    [theme.breakpoints.only('xs')]: {
      minHeight: 250,
    },
  },
  animated: {
    transition: `transform ${TRANSITION_TIME}`,
    '&:after': {
      transition: `opacity ${TRANSITION_TIME}`,
    },
  },
  gallery: {
    position: 'relative',
    minHeight: 500,
    width: '100%',
    cursor: 'pointer',
    [theme.breakpoints.only('xs')]: {
      minHeight: 250,
    },
  },
  off: {
    '&:after': {
      opacity: 0.8,
    },
  },
}));

const GalleryImage = (
  image,
  position,
  offset,
  isMain,
  animateSlider,
  resetFunc,
) => {
  const translate = 100 * (position - offset);
  const classes = useStyles();
  return (
    <div
      key={position}
      className={cx(
        classes.slide,
        !isMain && classes.off,
        animateSlider && classes.animated,
      )}
      onTransitionEnd={resetFunc}
      style={{
        backgroundImage: `url(${image})`,
        transform: `translate(${translate}%, 0)`,
      }}
    />
  );
};

const GallerySection = props => {
  const {
    images,
    LinkComponent: Link,
    LinkProps,
  } = props;
  const classes = useStyles();
  const [galleryState, setGalleryState] = React.useState({
    offset: 2,
    animateSlider: true,
    direction: null,
    autoCycle: true,
  });

  useInterval(() => {
    if (galleryState.autoCycle) {
      const newOffset = galleryState.offset + 1;
      // if (newOffset > images.length - 1) newOffset = 0;
      setGalleryState({
        ...galleryState,
        animateSlider: true,
        offset: newOffset,
        direction: 'right',
      });
    }
  }, INTERVAL_DELAY);

  const handleResetGallery = () => {
    const { offset, animateSlider, direction } = galleryState;
    if (offset >= images.length - 2 && animateSlider && direction === 'right') {
      const newOffset = 2;
      setGalleryState({
        ...galleryState,
        animateSlider: false,
        offset: newOffset,
      });
    }
    if (offset <= 2 && animateSlider && direction === 'left') {
      const newOffset = images.length - 2;
      setGalleryState({
        ...galleryState,
        animateSlider: false,
        offset: newOffset,
      });
    }
  };

  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;

  return (
    <Wrap
      maxWidth={1020}
      noPadding
      className={cx(classes.galleryWrap)}
      onMouseOver={() => {
        setGalleryState({ ...galleryState, autoCycle: false });
      }}
      onMouseOut={() => {
        setGalleryState({ ...galleryState, autoCycle: true });
      }}
    >
      <Link href={`${linkContext}unsere-heizung`} {...LinkProps}>
        <Box className={classes.gallery}>
          {images.map((image, index) =>
            GalleryImage(
              image,
              index,
              galleryState.offset,
              index - galleryState.offset === 0,
              galleryState.animateSlider,
              handleResetGallery,
            ),
          )}
        </Box>
      </Link>
    </Wrap>
  );
};

GallerySection.defaultProps = {
  images: [],
  LinkComponent: NextLink,
  LinkProps: {},
};

export default GallerySection;
